[
  {
    "code": "NZ-AUK",
    "name": "Auckland"
  },
  {
    "code": "NZ-BOP",
    "name": "Bay of Plenty"
  },
  {
    "code": "NZ-CAN",
    "name": "Canterbury"
  },
  {
    "code": "NZ-CI",
    "name": "Chatham Islands"
  },
  {
    "code": "NZ-GIS",
    "name": "Gisborne"
  },
  {
    "code": "NZ-HKB",
    "name": "Hawke's Bay"
  },
  {
    "code": "NZ-MWT",
    "name": "Manawatu-Wanganui"
  },
  {
    "code": "NZ-MBH",
    "name": "Marlborough"
  },
  {
    "code": "NZ-NSN",
    "name": "Nelson"
  },
  {
    "code": "NZ-NTL",
    "name": "Northland"
  },
  {
    "code": "NZ-OTA",
    "name": "Otago"
  },
  {
    "code": "NZ-STL",
    "name": "Southland"
  },
  {
    "code": "NZ-TKI",
    "name": "Taranaki"
  },
  {
    "code": "NZ-TAS",
    "name": "Tasman"
  },
  {
    "code": "NZ-WKO",
    "name": "Waikato"
  },
  {
    "code": "NZ-WGN",
    "name": "Wellington"
  },
  {
    "code": "NZ-WTC",
    "name": "West Coast"
  }
]